// extracted by mini-css-extract-plugin
export default {"iconsContainer":"FilterIcon_iconsContainer__MrhN7","indicator":"FilterIcon_indicator__s-KHn","filterIcon":"FilterIcon_filterIcon__FaIaJ"};